export function displayPlanName(value) {
  if (!value) return '';
  return String(value).replace(/\s+[—–]\s+[\d,]+\s+credits?\b.*$/i, '').trim();
}
